exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-center[data-v-9d8b1d00] {\n  position: absolute;\n  top: 35%;\n  z-index: 1;\n}\n", ""]);

// exports
